import { Row, Col } from "../../ui/ot";
import { Form, ColorPicker, InputNumber } from "antd";
import dayjs from "dayjs";
import React, { useEffect, useState, useRef } from "react";

const ColorForm = ({
  propsForm = null,
  formReloadCount = 0,
  selectOption = [],
  onFormFinish = () => {},
}) => {
  const [form] = Form.useForm();
  const setFormValuesOtherThings = (formValues) => {
    let newFormValues = {
      ...formValues,
      total: formValues?.comments * formValues?.number || 0,
    };
    if (propsForm) {
      propsForm.setFieldsValue(newFormValues);
    } else {
      form.setFieldsValue(newFormValues);
    }
  };

  const onChangeFileValue = (values) => {};
  const setDataInitialization = () => {};
  const onFinish = (values) => {
    let news_time = dayjs(values?.news_time).format("YYYY-MM-DD HH:mm:ss");
    let announce_time_end = dayjs(values?.announce_time_end).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    console.log(values.information_community_data);
    onFormFinish({
      ...values,
      news_time,
      announce_time_end,
    });
    form.resetFields();
  };

  const onValuesChange = () => {
    let formValues = null;
    if (propsForm) {
      formValues = propsForm.getFieldsValue();
    } else {
      formValues = form.getFieldsValue();
    }
    setFormValuesOtherThings(formValues);
  };

  useEffect(() => {
    setDataInitialization();
  }, []);
  useEffect(() => {
    let formValues = null;
    if (propsForm) {
      formValues = propsForm.getFieldsValue();
    } else {
      formValues = form.getFieldsValue();
    }
    onChangeFileValue(formValues);
  }, [formReloadCount]);

  return (
    <Row gutter={[10, 20]} justify="space-around" style={{ padding: "3vmin" }}>
      <Col span={24}>
        <Form
          layout="vertical"
          form={propsForm ? propsForm : form}
          onValuesChange={onValuesChange}
          onFinish={onFinish}
          autoComplete="off"
        >
          <Form.Item
          name="colorPrimary"
          label="網站色調"
          trigger="onChangeComplete"
          getValueFromEvent={(color) => color.toHexString()}
        >
          <ColorPicker />
        </Form.Item>    
        <Form.Item
          name="colorPrimary"
          label="字體大小"
          trigger="onChangeComplete"
          getValueFromEvent={(color) => color.toHexString()}
        >
        <InputNumber size="large" min={1} max={100000} defaultValue={3} />
        </Form.Item>

        </Form>
      </Col>
    </Row>
  );
};

export default ColorForm;
